import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'app-eye',
  templateUrl: './eye.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeComponent {
  @Input()
  public fillColor: string | undefined;
}
